import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { submitNipApplication } from "../../../redux/Actions/NipOnboardingActions";
import { getStorageItem } from "../../UserNav/getStorageItem";
import Pending from "./Nip-Doc-Upload/Pending";
import Rejected from "./Nip-Doc-Upload/Rejected";
import TestData from "./Nip-Doc-Upload/TestData";
import UploadDocs from "./Nip-Doc-Upload/UploadDocs";

const DocumentUpload = (props) => {
  const {
    selection,
    showDocUpload,
    isSubmitting,
    submitSuccess,
    submitApplication,
    acctNumber,
    uploadFinishStatus,
    docApproval,
    application,
    getAllApplications,
    getSingleApplication,
    docs,
  } = props;

  let { type } = getStorageItem();
  const status = application && application.status;
  const reason = application && application.reject_reason;

  return (
    <div className="doc-upload">
      {!uploadFinishStatus && !docApproval && !status && (
        <div>
          {selection === "outward_integration" ? (
            <UploadDocs
              success={submitSuccess}
              submitValues={submitApplication}
              selection={selection}
              isSubmitting={isSubmitting}
              acctNumber={acctNumber}
              getAllApplications={getAllApplications}
              documents={docs}
            />
          ) : (
            <TestData
              goToNext={showDocUpload}
              selection={selection}
              submitSuccess={submitSuccess}
              submitValues={submitApplication}
              isSubmitting={isSubmitting}
              getAllApplications={getAllApplications}
              documents={docs}
            />
          )}
        </div>
      )}
      {!docApproval && status === "pending" && <Pending />}
      {!docApproval && status === "rejected" && (
        <Rejected
          id={application && application.application_id}
          uploadedFiles={application && application.documents}
          success={submitSuccess}
          submitValues={submitApplication}
          isSubmitting={isSubmitting}
          getSingleApplication={getSingleApplication}
          reason={reason}
          documents={docs}
          userType={type}
        />
      )}
    </div>
  );
};

DocumentUpload.propTypes = {
  acctNumber: PropTypes.any,
  application: PropTypes.shape({
    application_id: PropTypes.any,
    documents: PropTypes.any,
    reject_reason: PropTypes.any,
    status: PropTypes.any,
  }),
  docApproval: PropTypes.any,
  docs: PropTypes.any,
  getAllApplications: PropTypes.any,
  getSingleApplication: PropTypes.any,
  goToNext: PropTypes.any,
  isSubmitting: PropTypes.any,
  selection: PropTypes.string,
  showDocUpload: PropTypes.any,
  submitApplication: PropTypes.any,
  submitSuccess: PropTypes.any,
  uploadFinishStatus: PropTypes.any,
};
const mapStateToProps = (state) => {
  return {
    isSubmitting: state.nipOnboarding.isSubmittingApplication,
    submitSuccess: state.nipOnboarding.submitApplicationSuccess,
    submitted: state.nipOnboarding.submitApplication,
  };
};
const mapDispatchToProps = (dispatch) => ({
  submitApplication: (payload, type) =>
    dispatch(submitNipApplication(payload, type)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload);
